module.exports = new __parcel__URL__("configure-fields-dark.cda4df1f.png").toString();